import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../../models/Offset';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {MatDialog} from '@angular/material/dialog';
import {UserModel} from '../../../../models/UserModel';
import {TerminationFeeService} from '../service-termination-fee/termination-fee.service';
import {TerminationFeeModel} from '../../../../models/TerminationFeeModel';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import {ContractTypeFilterComponent} from '../../../general-components/filter/contract-type-filter/contract-type-filter.component';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import {BaseGeneralComponent} from "../../../BaseGeneralComponent";

@Component({
  selector: 'app-filter-termination-fee',
  templateUrl: './filter-termination-fee.component.html',
  styleUrls: ['./filter-termination-fee.component.scss']
})
export class FilterTerminationFeeComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() numAnnoMeseData?: any;
  @Input() filter?: TerminationFeeModel;
  @Input() reportSection?: boolean;

  regionData: any;
  localCustomerData: any;
  contractTypeData: any;
  resourceUnitData: any;


  @Output() dataFiltered = new EventEmitter<any>();

  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;
  @ViewChild(RegionFilterComponent) regionFilterComponent;
  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(ContractTypeFilterComponent) contractTypeFilterComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private terminationFeeService: TerminationFeeService,
              private numAnnoMeseService: NumAnnoMeseService,
              private providerService: ProviderAnagrafService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new TerminationFeeModel();
    }
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromTerminationFeeModel(this.filter);
    this.offset = new Offset(10, 0);
    if (this.showNewEditDelete === undefined) {
      let user: UserModel;
      this.showNewEditDelete = true;
      user = JSON.parse(sessionStorage.getItem('user'));
      this.filter.region = user.regionList[0];
      this.filterSingle.region = user.regionList[0];
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {

    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel
    ).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();



    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable, getAllContractTypeObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.resourceUnitData = null;
          this.contractTypeData = resultFork[2];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.serviceVariant = null;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();


    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.resourceUnitData = null;
          this.contractTypeData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.serviceVariant = null;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }


  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();


    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.resourceUnitData = null;

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.serviceVariant = null;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }


  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.TERMINATION_FEE_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new TerminationFeeModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromTerminationFeeModel(this.filter);

    this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        const providerDefault = this.filter.provider;
        this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

        const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
        this.filter.numAnnoMese = numAnnoMese;

        sessionStorage.setItem(this.SESSION_STORAGE_LABELS.TERMINATION_FEE_FILTER, JSON.stringify(this.filter));
        this.filterSingle = AllSettingsFilterModel.getFromTerminationFeeModel(this.filter);

        this.initFilter(this.filterSingle, isReset);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
    });
  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }

    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.contractType = this.contractTypeFilterComponent.optionSelected;
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.terminationFeeService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.terminationFeeService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();
    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.TERMINATION_FEE_SERVICE}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  ngOnDestroy(): void {
  }
}
